import { Link } from "react-router-dom";
export default function SupportSection() {
  return (
    <section id="support" className="py-16 lg:py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Need help?
          </h2>
          <p className="text-lg text-gray-600">
            Our support team is here to assist you.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <Link to="/"
            className="bg-white rounded-2xl p-6 lg:p-8 hover:shadow-lg transition-shadow cursor-pointer group border border-gray-100 flex flex-col items-center text-center"
          >
            <div className="w-14 h-14 bg-[#4C6FFF]/10 rounded-xl flex items-center justify-center mb-4 group-hover:bg-[#4C6FFF]/20 transition-colors">
              <i className="ri-book-open-line text-2xl text-[#4C6FFF]"></i>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Help Center</h3>
            <p className="text-gray-600 text-sm">
              Browse guides, tutorials, and answers to common questions.
            </p>
          </Link>

          <Link to="/"
            className="bg-white rounded-2xl p-6 lg:p-8 hover:shadow-lg transition-shadow cursor-pointer group border border-gray-100 flex flex-col items-center text-center"
          >
            <div className="w-14 h-14 bg-[#00D0A3]/10 rounded-xl flex items-center justify-center mb-4 group-hover:bg-[#00D0A3]/20 transition-colors">
              <i className="ri-customer-service-2-line text-2xl text-[#00D0A3]"></i>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Contact Support</h3>
            <p className="text-gray-600 text-sm">
              Can't find what you need? Reach out to our support team.
            </p>
          </Link>
        </div>
      </div>
    </section>
  );
}
